import React from "react";
import TimeAgo from 'react-timeago';
import classNames from 'classnames';
import { Link, ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import get from "lodash/get";

import { Author } from "./author.js";
import { ImageFallback } from "./image-fallback.js";
import { SectionName } from "./section-name.js";
import { altTagOfHeroImages} from "../../utils";

function MediaObject({story = {}, config = {}}) {
  const author = {
    name: get(story, ['authors', 0, 'name'], story['author-name']),
    id: get(story, ['authors' , 0, 'id'] , story['author-id'])
  };
  const date =  config.storyTime && (story['last-published-at'] ? story['last-published-at'] :story['first-published-at']) 
  const isReviewStory = story["story-template"] === 'review';

  return story &&
    <Link href={"/" + story.slug}
      className={classNames('media', {'media--bg-white': !config.noBackground, 'media--with-shadow': !config.noBackground})}>
      <div className="media__img">
        { story["hero-image-s3-key"] ?
        <figure className={`media__img--${story['story-template']}`}>
          <ResponsiveHeroImage story={story}
            aspectRatio={config.aspectRatio ? config.aspectRatio : [4, 3]}
             alt={altTagOfHeroImages(story)}
            defaultWidth={480} widths={[250,480,640]}
            imgParams={{auto:['format', 'compress'], fit:'max'}}/>
        </figure> :
        <ImageFallback /> }
      </div>
      <div className={classNames('media__content', {'media__content--enlarged': config.enlarged})}>
        { config.section && <SectionName hideLink name={story.sections[0]['display-name'] || story.sections[0]['name']} section={story.sections[0]}/>}
        <h2 data-media-title="true" className={classNames('media-title', {'media__title--enlarged': config.enlarged})}><bdi dangerouslySetInnerHTML={ {__html: story.headline }} ></bdi></h2>
        { isReviewStory && <ReviewRating value={get(story, ['metadata','review-rating', 'value'], '0')} /> }
        <Author author={author} date={date} config={config}/>
      </div>
    </Link>
}

function MediaObjectsList(props) {
  return (
    <div>
      {props.stories.slice(0,3).map(storyObj =>{
          const story = storyObj && storyObj.story ? storyObj.story : storyObj;
          return <MediaObject story={story} key={story.id}/>
        }
      )}
    </div>
  )
}

export { MediaObject };
export { MediaObjectsList };
